/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R2faSetupRouteImport } from './routes/2fa-setup'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAuditLogRouteImport } from './routes/_authenticated/audit-log'
import { Route as AuthenticatedBackupsRouteImport } from './routes/_authenticated/backups'
import { Route as AuthenticatedMonitoringRouteImport } from './routes/_authenticated/monitoring'
import { Route as LoginVerify2faRouteImport } from './routes/login_.verify-2fa'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsAdminInvitesRouteImport } from './routes/_authenticated/settings/admin-invites'
import { Route as AuthenticatedSettingsDevModeRouteImport } from './routes/_authenticated/settings/dev-mode'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsThemeRouteImport } from './routes/_authenticated/settings/theme'
import { Route as AuthenticatedTenantsIndexRouteImport } from './routes/_authenticated/tenants/index'
import { Route as AuthenticatedTenantsIdRouteImport } from './routes/_authenticated/tenants/$id'
import { Route as AuthenticatedTenantsNewRouteImport } from './routes/_authenticated/tenants/new'
import { Route as AuthenticatedTenantsIdIndexRouteImport } from './routes/_authenticated/tenants/$id/index'
import { Route as AuthenticatedTenantsIdAuditRouteImport } from './routes/_authenticated/tenants/$id/audit'
import { Route as AuthenticatedTenantsIdBackupsRouteImport } from './routes/_authenticated/tenants/$id/backups'
import { Route as AuthenticatedTenantsIdFeaturesRouteImport } from './routes/_authenticated/tenants/$id/features'
import { Route as AuthenticatedTenantsIdHealthRouteImport } from './routes/_authenticated/tenants/$id/health'
import { Route as AuthenticatedTenantsIdJobsRouteImport } from './routes/_authenticated/tenants/$id/jobs'
import { Route as AuthenticatedTenantsIdLimitsRouteImport } from './routes/_authenticated/tenants/$id/limits'
import { Route as AuthenticatedTenantsIdUsersRouteImport } from './routes/_authenticated/tenants/$id/users'

const R2faSetupRoute = R2faSetupRouteImport.update({
  id: '/2fa-setup',
  path: '/2fa-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditLogRoute = AuthenticatedAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBackupsRoute = AuthenticatedBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMonitoringRoute = AuthenticatedMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const LoginVerify2faRoute = LoginVerify2faRouteImport.update({
  id: '/login_/verify-2fa',
  path: '/login/verify-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAdminInvitesRoute =
  AuthenticatedSettingsAdminInvitesRouteImport.update({
    id: '/settings/admin-invites',
    path: '/settings/admin-invites',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsDevModeRoute =
  AuthenticatedSettingsDevModeRouteImport.update({
    id: '/settings/dev-mode',
    path: '/settings/dev-mode',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/settings/security',
    path: '/settings/security',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsThemeRoute =
  AuthenticatedSettingsThemeRouteImport.update({
    id: '/settings/theme',
    path: '/settings/theme',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTenantsIndexRoute =
  AuthenticatedTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTenantsIdRoute = AuthenticatedTenantsIdRouteImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTenantsNewRoute = AuthenticatedTenantsNewRouteImport.update({
  id: '/tenants/new',
  path: '/tenants/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTenantsIdIndexRoute =
  AuthenticatedTenantsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdAuditRoute =
  AuthenticatedTenantsIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdBackupsRoute =
  AuthenticatedTenantsIdBackupsRouteImport.update({
    id: '/backups',
    path: '/backups',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdFeaturesRoute =
  AuthenticatedTenantsIdFeaturesRouteImport.update({
    id: '/features',
    path: '/features',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdHealthRoute =
  AuthenticatedTenantsIdHealthRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdJobsRoute =
  AuthenticatedTenantsIdJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdLimitsRoute =
  AuthenticatedTenantsIdLimitsRouteImport.update({
    id: '/limits',
    path: '/limits',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)
const AuthenticatedTenantsIdUsersRoute =
  AuthenticatedTenantsIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedTenantsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/2fa-setup': typeof R2faSetupRoute
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/backups': typeof AuthenticatedBackupsRoute
  '/monitoring': typeof AuthenticatedMonitoringRoute
  '/login/verify-2fa': typeof LoginVerify2faRoute
  '/settings/admin-invites': typeof AuthenticatedSettingsAdminInvitesRoute
  '/settings/dev-mode': typeof AuthenticatedSettingsDevModeRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/theme': typeof AuthenticatedSettingsThemeRoute
  '/tenants/$id': typeof AuthenticatedTenantsIdRouteWithChildren
  '/tenants/new': typeof AuthenticatedTenantsNewRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tenants/': typeof AuthenticatedTenantsIndexRoute
  '/tenants/$id/audit': typeof AuthenticatedTenantsIdAuditRoute
  '/tenants/$id/backups': typeof AuthenticatedTenantsIdBackupsRoute
  '/tenants/$id/features': typeof AuthenticatedTenantsIdFeaturesRoute
  '/tenants/$id/health': typeof AuthenticatedTenantsIdHealthRoute
  '/tenants/$id/jobs': typeof AuthenticatedTenantsIdJobsRoute
  '/tenants/$id/limits': typeof AuthenticatedTenantsIdLimitsRoute
  '/tenants/$id/users': typeof AuthenticatedTenantsIdUsersRoute
  '/tenants/$id/': typeof AuthenticatedTenantsIdIndexRoute
}
export interface FileRoutesByTo {
  '/2fa-setup': typeof R2faSetupRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/backups': typeof AuthenticatedBackupsRoute
  '/monitoring': typeof AuthenticatedMonitoringRoute
  '/login/verify-2fa': typeof LoginVerify2faRoute
  '/': typeof AuthenticatedIndexRoute
  '/settings/admin-invites': typeof AuthenticatedSettingsAdminInvitesRoute
  '/settings/dev-mode': typeof AuthenticatedSettingsDevModeRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/theme': typeof AuthenticatedSettingsThemeRoute
  '/tenants/new': typeof AuthenticatedTenantsNewRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tenants': typeof AuthenticatedTenantsIndexRoute
  '/tenants/$id/audit': typeof AuthenticatedTenantsIdAuditRoute
  '/tenants/$id/backups': typeof AuthenticatedTenantsIdBackupsRoute
  '/tenants/$id/features': typeof AuthenticatedTenantsIdFeaturesRoute
  '/tenants/$id/health': typeof AuthenticatedTenantsIdHealthRoute
  '/tenants/$id/jobs': typeof AuthenticatedTenantsIdJobsRoute
  '/tenants/$id/limits': typeof AuthenticatedTenantsIdLimitsRoute
  '/tenants/$id/users': typeof AuthenticatedTenantsIdUsersRoute
  '/tenants/$id': typeof AuthenticatedTenantsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/2fa-setup': typeof R2faSetupRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/audit-log': typeof AuthenticatedAuditLogRoute
  '/_authenticated/backups': typeof AuthenticatedBackupsRoute
  '/_authenticated/monitoring': typeof AuthenticatedMonitoringRoute
  '/login_/verify-2fa': typeof LoginVerify2faRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/settings/admin-invites': typeof AuthenticatedSettingsAdminInvitesRoute
  '/_authenticated/settings/dev-mode': typeof AuthenticatedSettingsDevModeRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/settings/theme': typeof AuthenticatedSettingsThemeRoute
  '/_authenticated/tenants/$id': typeof AuthenticatedTenantsIdRouteWithChildren
  '/_authenticated/tenants/new': typeof AuthenticatedTenantsNewRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tenants/': typeof AuthenticatedTenantsIndexRoute
  '/_authenticated/tenants/$id/audit': typeof AuthenticatedTenantsIdAuditRoute
  '/_authenticated/tenants/$id/backups': typeof AuthenticatedTenantsIdBackupsRoute
  '/_authenticated/tenants/$id/features': typeof AuthenticatedTenantsIdFeaturesRoute
  '/_authenticated/tenants/$id/health': typeof AuthenticatedTenantsIdHealthRoute
  '/_authenticated/tenants/$id/jobs': typeof AuthenticatedTenantsIdJobsRoute
  '/_authenticated/tenants/$id/limits': typeof AuthenticatedTenantsIdLimitsRoute
  '/_authenticated/tenants/$id/users': typeof AuthenticatedTenantsIdUsersRoute
  '/_authenticated/tenants/$id/': typeof AuthenticatedTenantsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/2fa-setup'
    | '/'
    | '/login'
    | '/register'
    | '/audit-log'
    | '/backups'
    | '/monitoring'
    | '/login/verify-2fa'
    | '/settings/admin-invites'
    | '/settings/dev-mode'
    | '/settings/security'
    | '/settings/theme'
    | '/tenants/$id'
    | '/tenants/new'
    | '/settings/'
    | '/tenants/'
    | '/tenants/$id/audit'
    | '/tenants/$id/backups'
    | '/tenants/$id/features'
    | '/tenants/$id/health'
    | '/tenants/$id/jobs'
    | '/tenants/$id/limits'
    | '/tenants/$id/users'
    | '/tenants/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/2fa-setup'
    | '/login'
    | '/register'
    | '/audit-log'
    | '/backups'
    | '/monitoring'
    | '/login/verify-2fa'
    | '/'
    | '/settings/admin-invites'
    | '/settings/dev-mode'
    | '/settings/security'
    | '/settings/theme'
    | '/tenants/new'
    | '/settings'
    | '/tenants'
    | '/tenants/$id/audit'
    | '/tenants/$id/backups'
    | '/tenants/$id/features'
    | '/tenants/$id/health'
    | '/tenants/$id/jobs'
    | '/tenants/$id/limits'
    | '/tenants/$id/users'
    | '/tenants/$id'
  id:
    | '__root__'
    | '/2fa-setup'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/_authenticated/audit-log'
    | '/_authenticated/backups'
    | '/_authenticated/monitoring'
    | '/login_/verify-2fa'
    | '/_authenticated/'
    | '/_authenticated/settings/admin-invites'
    | '/_authenticated/settings/dev-mode'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/theme'
    | '/_authenticated/tenants/$id'
    | '/_authenticated/tenants/new'
    | '/_authenticated/settings/'
    | '/_authenticated/tenants/'
    | '/_authenticated/tenants/$id/audit'
    | '/_authenticated/tenants/$id/backups'
    | '/_authenticated/tenants/$id/features'
    | '/_authenticated/tenants/$id/health'
    | '/_authenticated/tenants/$id/jobs'
    | '/_authenticated/tenants/$id/limits'
    | '/_authenticated/tenants/$id/users'
    | '/_authenticated/tenants/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R2faSetupRoute: typeof R2faSetupRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  LoginVerify2faRoute: typeof LoginVerify2faRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/2fa-setup': {
      id: '/2fa-setup'
      path: '/2fa-setup'
      fullPath: '/2fa-setup'
      preLoaderRoute: typeof R2faSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit-log': {
      id: '/_authenticated/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuthenticatedAuditLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/backups': {
      id: '/_authenticated/backups'
      path: '/backups'
      fullPath: '/backups'
      preLoaderRoute: typeof AuthenticatedBackupsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/monitoring': {
      id: '/_authenticated/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof AuthenticatedMonitoringRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/login_/verify-2fa': {
      id: '/login_/verify-2fa'
      path: '/login/verify-2fa'
      fullPath: '/login/verify-2fa'
      preLoaderRoute: typeof LoginVerify2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/admin-invites': {
      id: '/_authenticated/settings/admin-invites'
      path: '/settings/admin-invites'
      fullPath: '/settings/admin-invites'
      preLoaderRoute: typeof AuthenticatedSettingsAdminInvitesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/dev-mode': {
      id: '/_authenticated/settings/dev-mode'
      path: '/settings/dev-mode'
      fullPath: '/settings/dev-mode'
      preLoaderRoute: typeof AuthenticatedSettingsDevModeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/theme': {
      id: '/_authenticated/settings/theme'
      path: '/settings/theme'
      fullPath: '/settings/theme'
      preLoaderRoute: typeof AuthenticatedSettingsThemeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/': {
      id: '/_authenticated/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AuthenticatedTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/$id': {
      id: '/_authenticated/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/tenants/$id'
      preLoaderRoute: typeof AuthenticatedTenantsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/new': {
      id: '/_authenticated/tenants/new'
      path: '/tenants/new'
      fullPath: '/tenants/new'
      preLoaderRoute: typeof AuthenticatedTenantsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/$id/': {
      id: '/_authenticated/tenants/$id/'
      path: '/'
      fullPath: '/tenants/$id/'
      preLoaderRoute: typeof AuthenticatedTenantsIdIndexRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/audit': {
      id: '/_authenticated/tenants/$id/audit'
      path: '/audit'
      fullPath: '/tenants/$id/audit'
      preLoaderRoute: typeof AuthenticatedTenantsIdAuditRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/backups': {
      id: '/_authenticated/tenants/$id/backups'
      path: '/backups'
      fullPath: '/tenants/$id/backups'
      preLoaderRoute: typeof AuthenticatedTenantsIdBackupsRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/features': {
      id: '/_authenticated/tenants/$id/features'
      path: '/features'
      fullPath: '/tenants/$id/features'
      preLoaderRoute: typeof AuthenticatedTenantsIdFeaturesRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/health': {
      id: '/_authenticated/tenants/$id/health'
      path: '/health'
      fullPath: '/tenants/$id/health'
      preLoaderRoute: typeof AuthenticatedTenantsIdHealthRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/jobs': {
      id: '/_authenticated/tenants/$id/jobs'
      path: '/jobs'
      fullPath: '/tenants/$id/jobs'
      preLoaderRoute: typeof AuthenticatedTenantsIdJobsRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/limits': {
      id: '/_authenticated/tenants/$id/limits'
      path: '/limits'
      fullPath: '/tenants/$id/limits'
      preLoaderRoute: typeof AuthenticatedTenantsIdLimitsRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
    '/_authenticated/tenants/$id/users': {
      id: '/_authenticated/tenants/$id/users'
      path: '/users'
      fullPath: '/tenants/$id/users'
      preLoaderRoute: typeof AuthenticatedTenantsIdUsersRouteImport
      parentRoute: typeof AuthenticatedTenantsIdRoute
    }
  }
}

interface AuthenticatedTenantsIdRouteChildren {
  AuthenticatedTenantsIdAuditRoute: typeof AuthenticatedTenantsIdAuditRoute
  AuthenticatedTenantsIdBackupsRoute: typeof AuthenticatedTenantsIdBackupsRoute
  AuthenticatedTenantsIdFeaturesRoute: typeof AuthenticatedTenantsIdFeaturesRoute
  AuthenticatedTenantsIdHealthRoute: typeof AuthenticatedTenantsIdHealthRoute
  AuthenticatedTenantsIdJobsRoute: typeof AuthenticatedTenantsIdJobsRoute
  AuthenticatedTenantsIdLimitsRoute: typeof AuthenticatedTenantsIdLimitsRoute
  AuthenticatedTenantsIdUsersRoute: typeof AuthenticatedTenantsIdUsersRoute
  AuthenticatedTenantsIdIndexRoute: typeof AuthenticatedTenantsIdIndexRoute
}

const AuthenticatedTenantsIdRouteChildren: AuthenticatedTenantsIdRouteChildren =
  {
    AuthenticatedTenantsIdAuditRoute: AuthenticatedTenantsIdAuditRoute,
    AuthenticatedTenantsIdBackupsRoute: AuthenticatedTenantsIdBackupsRoute,
    AuthenticatedTenantsIdFeaturesRoute: AuthenticatedTenantsIdFeaturesRoute,
    AuthenticatedTenantsIdHealthRoute: AuthenticatedTenantsIdHealthRoute,
    AuthenticatedTenantsIdJobsRoute: AuthenticatedTenantsIdJobsRoute,
    AuthenticatedTenantsIdLimitsRoute: AuthenticatedTenantsIdLimitsRoute,
    AuthenticatedTenantsIdUsersRoute: AuthenticatedTenantsIdUsersRoute,
    AuthenticatedTenantsIdIndexRoute: AuthenticatedTenantsIdIndexRoute,
  }

const AuthenticatedTenantsIdRouteWithChildren =
  AuthenticatedTenantsIdRoute._addFileChildren(
    AuthenticatedTenantsIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAuditLogRoute: typeof AuthenticatedAuditLogRoute
  AuthenticatedBackupsRoute: typeof AuthenticatedBackupsRoute
  AuthenticatedMonitoringRoute: typeof AuthenticatedMonitoringRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedSettingsAdminInvitesRoute: typeof AuthenticatedSettingsAdminInvitesRoute
  AuthenticatedSettingsDevModeRoute: typeof AuthenticatedSettingsDevModeRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsThemeRoute: typeof AuthenticatedSettingsThemeRoute
  AuthenticatedTenantsIdRoute: typeof AuthenticatedTenantsIdRouteWithChildren
  AuthenticatedTenantsNewRoute: typeof AuthenticatedTenantsNewRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTenantsIndexRoute: typeof AuthenticatedTenantsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditLogRoute: AuthenticatedAuditLogRoute,
  AuthenticatedBackupsRoute: AuthenticatedBackupsRoute,
  AuthenticatedMonitoringRoute: AuthenticatedMonitoringRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedSettingsAdminInvitesRoute:
    AuthenticatedSettingsAdminInvitesRoute,
  AuthenticatedSettingsDevModeRoute: AuthenticatedSettingsDevModeRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedSettingsThemeRoute: AuthenticatedSettingsThemeRoute,
  AuthenticatedTenantsIdRoute: AuthenticatedTenantsIdRouteWithChildren,
  AuthenticatedTenantsNewRoute: AuthenticatedTenantsNewRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTenantsIndexRoute: AuthenticatedTenantsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  R2faSetupRoute: R2faSetupRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  LoginVerify2faRoute: LoginVerify2faRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
